import Api from "../services/apis/setup";

const useHandleRefresh = (setLoading: any) => {
    const [fetchAllVehicles] = Api.useLazyFetchAllVehiclesQuery();

    const handleRefresh = async () => {
    setLoading(true);
    await fetchAllVehicles({
    baseURL: "/vehicles"
    });
    setLoading(false);
    };
    return handleRefresh;
};

export default useHandleRefresh;